export default "__VITE_ASSET__BmVyQoqH__"